/// <reference path="../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    import User = Models.User;

    /**
     * NetworkNodeController class
     */
    export class UserController {
        public static $name: string = "userController";
        public static $inject: string[] = ['userService', 'ModalService'];

        private user: User;

        /**
         * Constructor of the class.
         */
        constructor(private userService: Services.UserService,
                    private modalService: ngModal.IModalService) {
            this.initData();
        }

        public launchAvatarModal(): void {
            this.userService
                .findById(this.user.id as number)
                .then((completedUser: Models.IUser) => {
                    this.modalService.showModal({
                        templateUrl: Application.Controllers.AvatarModalController.templateURL,
                        controller: Application.Controllers.AvatarModalController.$name,
                        inputs: {
                            user: completedUser,
                        },
                    }).then((modal: ngModal.IModalObject) => {
                        let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.AvatarModalController.ID,
                            {bgclose: false, modal: false, keyboard: false});
                        modalElem.show();
                        modal.close.then((result?: Models.IUser) => {
                            modalElem.hide();
                            if (result) {
                                this.userService
                                    .saveUser(result)
                                    .then((response: Models.IUser) => {
                                        this.user = response;
                                    });
                            }
                        });
                    });
                });
        }

        public launchChangePasswordModal(): void {
            this.modalService.showModal({
                templateUrl: Application.Controllers.ChangePasswordModalController.templateURL,
                controller: Application.Controllers.ChangePasswordModalController.$name,
                inputs: {},
            }).then((modal: ngModal.IModalObject) => {
                let modalElem: UIkit.ModalElement = UIkit.modal(Application.Controllers.ChangePasswordModalController.ID,
                    {bgclose: false, modal: false, keyboard: false});
                modalElem.show();
                modal.close.then((result?: boolean) => {
                    modalElem.hide();
                });
            });
        }

        private initData(): void {
            this.userService.loadCurrentUser().then((user: User) => {
                this.user = user;
            });
        }
    }
}